// pages/messenger/messenger-profile.jsx
// ─────────────────────────────────────────────────────────
// หน้า "บัญชีของฉัน" สำหรับ Messenger
// URL: /messenger/profile
// ─────────────────────────────────────────────────────────

import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    GetDataFullName,
    GetDataEmail,
} from '../../components/utils/data-storage';

const MessengerProfile = () => {
    const navigate = useNavigate();

    const fullName = GetDataFullName() || '';
    const email    = GetDataEmail() || '';
    const [firstName = '', lastName = ''] = fullName.split(' ');

    const initials = `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase();

    const onClickLogout = () => {
        localStorage.clear();
        navigate('/login', { replace: true });
    };

    return (
        <div className="mpr-root">

            <div className="mpr-header">
                <button className="mpr-back-btn" onClick={() => navigate(-1)}>
                    <i className="mdi mdi-arrow-left" />
                </button>
                <h1 className="mpr-header-title">บัญชีของฉัน</h1>
            </div>

            <div className="mpr-content">

                <div className="mpr-avatar-wrap">
                    <div className="mpr-avatar-placeholder">
                        {initials || <i className="mdi mdi-account" />}
                    </div>
                </div>

                <div className="mpr-section">
                    <p className="mpr-section-title">ข้อมูลส่วนตัว</p>

                    <div className="mpr-box">
                        <div className="mpr-field">
                            <label className="mpr-label">ชื่อ</label>
                            <div className="mpr-value">{firstName}</div>
                        </div>

                        <div className="mpr-field">
                            <label className="mpr-label">นามสกุล</label>
                            <div className="mpr-value">{lastName}</div>
                        </div>

                        <div className="mpr-field">
                            <label className="mpr-label">อีเมล</label>
                            <div className="mpr-value">{email}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mpr-footer">
                <button className="mpr-logout-btn" onClick={onClickLogout}>
                    <i className="mdi mdi-logout" />
                    ออกจากระบบ
                </button>
            </div>

        </div>
    );
};

export default MessengerProfile;